import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { StyleSheet, View } from 'react-native';

import BrandedChip from '../BrandedChip';
import Text from '../Text';
import { OptionType } from './types';

export type ChipGroupProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  options: OptionType[];
  groupLabel?: React.ReactNode;
  showError?: boolean;
};

const ChipGroup = <T extends FieldValues>({
  name,
  control,
  options,
  groupLabel,
  showError = true
}: ChipGroupProps<T>) => (
  <Controller
    name={name}
    control={control}
    render={({ field: { value, onChange }, fieldState: { error } }) => (
      <View>
        {groupLabel && (
          <Text fontWeight="700" style={styles.groupLabel}>
            {groupLabel}
          </Text>
        )}

        <View style={styles.container}>
          {options.map((option, index) => (
            <BrandedChip
              key={index}
              isSelected={option.value === value}
              value={option.label}
              onPress={() => onChange(option.value)}
            />
          ))}
        </View>
        {showError && !!error?.message && <Text style={styles.errorText}>{error.message}</Text>}
      </View>
    )}
  />
);

export default ChipGroup;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 10,
    justifyContent: 'center'
  },

  groupLabel: {
    marginBottom: 10,
    color: 'black'
  },

  labelText: {
    fontSize: 14,
    fontWeight: '400'
  },

  errorText: {
    marginTop: 10,
    fontSize: 12,
    color: 'red'
  }
});
